import React, { useState, useEffect } from "react";
import { Target, Building, Eye, Heart } from "lucide-react";

const AboutSection = () => {
  return (
    <section
      id="about"
      className="py-24 bg-gradient-to-br from-slate-50 via-blue-50/50 to-emerald-50/50 relative overflow-hidden"
    >
      {/* Background pattern */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%2334d399' fill-opacity='1' fill-rule='evenodd'%3E%3Ccircle cx='3' cy='3' r='3'/%3E%3Ccircle cx='13' cy='13' r='3'/%3E%3C/g%3E%3C/svg%3E")`,
        }}
      ></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-block p-3 bg-gradient-to-r from-emerald-500/10 to-blue-500/10 rounded-full mb-6 border border-emerald-200">
            <Building className="w-8 h-8 text-emerald-600" />
          </div>
          <h2 className="text-5xl md:text-7xl font-black text-slate-900 mb-8">
            About{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-600 via-blue-600 to-yellow-500">
              Kuba Meridian
            </span>
          </h2>
          <div className="w-32 h-1.5 bg-gradient-to-r from-emerald-500 via-blue-500 to-yellow-500 mx-auto mb-10 rounded-full"></div>
          <p className="text-2xl text-slate-600 max-w-4xl mx-auto leading-relaxed font-light">
            Born from the rich heritage of African tradition and powered by
            global innovation, we are building the future of African enterprise.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-10">
            <div className="group bg-gradient-to-br from-blue-50 to-blue-100/50 p-10 rounded-3xl border border-blue-200/50 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
              <div className="flex items-center space-x-4 mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                  <Target className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-3xl font-bold text-slate-900">
                  Our Mission
                </h3>
              </div>
              <p className="text-slate-700 leading-relaxed text-lg">
                To create and nurture world-class subsidiaries that harness
                Africa's potential while contributing to global prosperity
                through excellence, innovation, and sustainable business
                practices.
              </p>
            </div>

            <div className="group bg-gradient-to-br from-emerald-50 to-emerald-100/50 p-10 rounded-3xl border border-emerald-200/50 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
              <div className="flex items-center space-x-4 mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                  <Eye className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-3xl font-bold text-slate-900">
                  Our Vision
                </h3>
              </div>
              <p className="text-slate-700 leading-relaxed text-lg">
                To be Africa's premier holding company, recognized globally for
                transforming industries, empowering communities, and building
                bridges between African heritage and international excellence.
              </p>
            </div>
          </div>

          <div className="relative">
            <div className="bg-gradient-to-br from-slate-900 via-blue-900 to-emerald-900 rounded-3xl p-12 text-white shadow-2xl transform rotate-2 hover:rotate-0 transition-all duration-700 border border-white/10">
              <div className="bg-gradient-to-br from-yellow-400/20 to-emerald-400/20 rounded-full w-24 h-24 flex items-center justify-center mb-8 backdrop-blur-sm border border-yellow-400/30 mx-auto">
                <Heart className="w-12 h-12 text-yellow-400" />
              </div>
              <h3 className="text-3xl font-bold mb-6 text-center">
                Heritage Meets Innovation
              </h3>
              <p className="text-slate-300 leading-relaxed mb-8 text-center text-lg">
                We bridge continents, cultures, and capabilities. Our roots run
                deep in African soil, while our branches reach toward global
                horizons, creating sustainable value for all stakeholders.
              </p>
              <div className="flex items-center justify-center space-x-6 text-yellow-400">
                <span className="font-bold text-xl">EST. 2024</span>
                <div className="w-3 h-3 bg-yellow-400 rounded-full animate-pulse"></div>
                <span className="font-bold text-xl">AFRICA & BEYOND</span>
              </div>
            </div>

            {/* Floating elements */}
            <div className="absolute -top-6 -right-6 w-12 h-12 bg-gradient-to-br from-yellow-400 to-emerald-400 rounded-full animate-bounce delay-300 shadow-lg"></div>
            <div className="absolute -bottom-4 -left-4 w-8 h-8 bg-gradient-to-br from-blue-400 to-yellow-400 rounded-full animate-pulse delay-700 shadow-lg"></div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default AboutSection;
